import styled from 'styled-components';

const ActionLink = styled.button`
    background: none;
    border: 0;
    cursor: pointer;
    display: inline;
    font: inherit;
    line-height: normal;
    margin: 0;
    padding: 0;
    text-align: center;
    text-decoration: underline;
    color: inherit;
`;

export default ActionLink;
